export default {"src":"/_next/static/media/php.bdee88ab.svg","height":258,"width":512,"blurWidth":0,"blurHeight":0};